<div #gmap id="map" style="height: 100vh; width: 100%;"></div>
<app-place-search style="position: absolute; top: calc(env(safe-area-inset-top) + 55px); left: 15px; z-index: 10000" (placeSelected)="search($event)"></app-place-search>
